import React, { ReactNode } from 'react';
import { Text as RNText, TextProps } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

type Props = TextProps & {
    trans?: string;
    children?: ReactNode;
};

export const Text = (props: Props) => {
    const { trans, children, ...rest } = props;
    const { t } = useTranslation();
    return (
        <RNText textStyle="md" {...rest}>
            {trans && t(trans)}
            {children}
        </RNText>
    );
};
